var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16C31.3044 16 16 18.0869 16 18.0869L0 16Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8055 12.7258L15.1619 13.7102L14.645 15.3044L16.0004 14.3184L17.3569 15.3028L16.8381 13.7091L18.1933 12.7232L16.5174 12.7242L15.9984 11.1305L15.4815 12.7247L13.8055 12.7258Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 9.07182C18.7389 8.34389 17.3603 8.00032 15.9997 8.0027V10.0892C17.0054 10.0874 18.0243 10.3411 18.9562 10.8793C21.7798 12.5095 22.7508 16.133 21.1204 18.9566C19.4903 21.7803 15.8668 22.7512 13.0431 21.1209C12.2205 20.646 11.5565 20.0011 11.067 19.2569L9.32471 20.4072C9.98702 21.414 10.8868 22.2857 11.9997 22.9282C15.8199 25.1338 20.7223 23.8203 22.9278 20C25.1334 16.1798 23.8199 11.2774 19.9997 9.07182V9.07182Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3864 14.6087C10.8333 15.6199 11.2047 16.8881 12.2158 17.4412L18.9939 21.145C18.5329 21.9875 18.7777 23.0131 19.6203 23.474L21.4512 24.4756C22.2938 24.9366 23.3507 24.6271 23.8117 23.7845L24.8132 21.9536L11.3864 14.6087Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/AO.e4138e16.svg";
export { ForwardRef as ReactComponent };